import { useId, useRef } from 'react';
import { Falcon } from 'modules/macro';
import { Loader } from 'modules/v2/feedback/Loader';
import { Menu } from '.';
import { IconButton } from '../buttons';
export function MenuHeaderSearch(props) {
    const { id, value, placeholder, loading, disabled, autoFocus = true, type = 'text', onChange, onClear } = props;
    const inputRef = useRef(null);
    const generatedId = useId();
    const inputId = id || generatedId;
    const showClearButton = Boolean(value && !loading && !disabled);
    const handleClear = () => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onChange === null || onChange === void 0 ? void 0 : onChange('');
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    const getActionsElement = () => {
        if (loading) {
            return <Loader size="xs"/>;
        }
        if (showClearButton) {
            return (<IconButton appearance="ghost" size="xs" onClick={handleClear}>
          <Falcon icon="xmark"/>
        </IconButton>);
        }
        return null;
    };
    return (<Menu.HeaderInput id={inputId} value={value} ref={inputRef} placeholder={placeholder} disabled={disabled} autoFocus={autoFocus} onChange={onChange} type={type} icon={<Falcon icon="search"/>} actions={getActionsElement()}/>);
}
